import React, { forwardRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// import required modules
import { FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';

const SwiperCardTags = forwardRef(({ slides }, ref) => {
  return (
    <Swiper
      className="swiper--tags"
      style={{ marginLeft: '-15px' }}
      spaceBetween={5}
      slidesPerView={'auto'}
      modules={[FreeMode]}
      freeMode={true}
      ref={ref}
      slidesOffsetAfter={20}
      slidesOffsetBefore={20}
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>{slide}</SwiperSlide>
      ))}
    </Swiper>
  );
});

SwiperCardTags.displayName = 'SwiperCardTags';

export default SwiperCardTags;
